import { getDY_SR } from "stackerConfig"

export function setPid(pid) {
  getDY_SR().data.pid = pid
}

export function removePid(pid) {
  getDY_SR().data.pid = ""
}
